import React from 'react';
import HeroSection from './HeroSection';
import DeepMirror from './DeepMirror';
import GrandIllusion from './GrandIllusion';
import ParadigmShift from './ParadigmShift';
import DeepCurriculum from './DeepCurriculum';
import JenniferGenesis from './JenniferGenesis';
import Gatekeeper from './Gatekeeper';
import FuturePacing from './FuturePacing';
import MasterclassFooter from './MasterclassFooter';

const MasterclassFunnel = () => (
  <main className="bg-dark min-h-screen overflow-x-hidden">
    <h1 className="sr-only">
      Love Shift & Feminine Business Masterclass – Kostenfreie Masterclass von Jennifer Gräser
    </h1>
    <HeroSection />
    <DeepMirror />
    <GrandIllusion />
    <ParadigmShift />
    <DeepCurriculum />
    <JenniferGenesis />
    <Gatekeeper />
    <FuturePacing />
    <MasterclassFooter />
  </main>
);

export default MasterclassFunnel;